<section class="container-legal-notice--xs">
  <h1 class="h2-like">Mentions légales</h1>

  <h2 class="h3-like">Editeur du site Ubilaw.com</h2>
  <p>
    UBILAW Groupement d'Intérêts Economique<br />13 rue du Général de
    Castelnau<br />67000 STRASBOURG
  </p>

  <h2 class="h3-like">Hébergement</h2>
  <p>
    Agora Calycé<br />5 rue Hannah Arendt<br />67200 Strasbourg<br />tél.: +33 3
    88 99 02 82
  </p>

  <h2 class="h3-like">Propriété intellectuelle</h2>
  <p>
    Le contenu de ce site, y compris les textes, images, sons et vidéos, est
    protégé par le droit d'auteur et par les autres lois relatives à la
    propriété intellectuelle. Toute reproduction, représentation, modification,
    publication, transmission, dénaturation, totale ou partielle du contenu de
    ce site, par quelque procédé que ce soit, sans autorisation préalable et
    express, est interdite et constitue une contrefaçon.
  </p>

  <h2 class="h3-like">Responsabilité</h2>
  <p>
    L'éditeur du site décline toute responsabilité quant à l'utilisation et à
    l'interprétation des informations contenues sur ce site. L'utilisateur est
    seul responsable de l'utilisation de ces informations.
  </p>

  <h2 class="h3-like">Données personnelles</h2>
  <p>
    Conformément à la réglementation en vigueur relative à la protection des
    données personnelles, vous disposez d'un droit d'accès, de modification, de
    rectification et de suppression des données personnelles vous concernant.
    Vous pouvez exercer ce droit en nous contactant à l'adresse email indiquée
    ci-dessus.
  </p>

  <h2 class="h3-like">Loi applicable</h2>
  <p>
    Ce site est soumis à la loi française. Tout litige en relation avec
    l'utilisation de ce site est de la compétence des tribunaux français.
  </p>
</section>
